/**
 * 地点単位のカード（`LaneCard`）のドラッグに載せるデータ。
 *
 * ドラッグの id は**配下の先頭伝票の id** にする。落とし先の処理は 3 画面それぞれが持ち、
 * どれも `active.id` で未割当リストを引いて「掴んだのが未割当か」を判定するため、
 * レーン固有の id にすると全画面の入口を書き換えることになる。先頭の伝票 id なら
 * 既存の判定をそのまま通せて、落とす対象だけをここで広げられる。
 *
 * 表示単位は排他（伝票単位か地点単位のどちらか）なので、同じ id の draggable が
 * 二重に登録されることはない。
 */
export const LANE_ITEM_IDS_KEY = 'laneItemIds';

type ActiveLike = { data?: { current?: Record<string, unknown> | null } | null };

/**
 * 掴んだものが地点単位のカードなら、配下の伝票 id を返す。伝票単位のカードなら null。
 * 値の形が違えば null に倒す（外から来たドラッグを信じない）。
 */
export function readLaneItemIds(active: ActiveLike): string[] | null {
  const raw = active.data?.current?.[LANE_ITEM_IDS_KEY];
  if (!Array.isArray(raw) || raw.length === 0) return null;
  return raw.every((id) => typeof id === 'string') ? raw : null;
}
